import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import {
  Box,
  Typography,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
} from '@mui/material';

import { usePrinterStore } from '../../stores';
import LoadingWrapper from '../../components/LoadingWrapper';
import PrinterEditDrawer from '../../components/printer/PrinterEditDrawer';
import Printer from '../../model/Printer';

const PrinterList = observer(() => {
  const printerStore = usePrinterStore();
  const [selectedPrinter, setSelectedPrinter] = useState<Printer | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        {t('printerScreen.title')}
      </Typography>
      <Paper sx={{ marginTop: 2, marginBottom: 2, padding: '1rem' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
          <Button
            variant="contained"
            disabled={printerStore.loading}
            onClick={() => {
              setModalOpen(true);
              setSelectedPrinter(null);
            }}
          >
            {t('printerScreen.addPrinter')}
          </Button>
        </Box>
        <LoadingWrapper loading={printerStore.loading}>
          <TableContainer sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('printerScreen.name')}</TableCell>
                  <TableCell>{t('printerScreen.type')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {printerStore.list.map((printer) => (
                  <TableRow
                    key={printer.id}
                    onClick={() => {
                      setModalOpen(true);
                      setSelectedPrinter(printer);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell>{printer.name}</TableCell>
                    <TableCell>{t(`printerScreen.printerTypes.${printer.type}`)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </LoadingWrapper>
      </Paper>
      <PrinterEditDrawer
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setSelectedPrinter(null);
        }}
        printer={selectedPrinter}
      />
    </Box>
  );
});

export default PrinterList;
